module.exports = __webpack_public_path__ + "assets/find-top-sales-talent-4.5bd15033.png";